export const PC_APPID = 'wx6b3e1b3da5cf19ab';
export const M_APPID = 'wx53b799aa586b0f97';
export const SCOPE = 'snsapi_login';
